module.exports = __webpack_public_path__ + "img/4_52.6951b400.png";